<template>
  <div v-if="!isMobile">
    <div class="right_bar">
      <div class="item_box" @mouseover="mouseOver(1)" @mouseout="mouseOut()">
        <img class="r_img" src="@/assets/r_weixin.png" alt="" />
        <div class="r_tx">微信</div>
      </div>
      <div class="item_box" @mouseover="mouseOver(2)" @mouseout="mouseOut()">
        <img class="r_img" src="@/assets/r_phone.png" alt="" />
        <div class="r_tx">电话</div>
      </div>
      <div class="item_box" @mouseover="mouseOver(3)" @mouseout="mouseOut()">
        <img class="r_img" src="@/assets/r_weixin.png" alt="" />
        <div class="r_tx">公众号</div>
      </div>
      <div class="item_box" @click="toTop()">
        <img class="r_img" src="@/assets/r_top.png" alt="" />
        <div class="r_tx">Top</div>
      </div>
      <div
        v-if="cIdex != null && cIdex != 4"
        class="right_r"
        :class="'r' + cIdex"
      ></div>
    </div>
    <div
      v-if="cIdex != null && cIdex != 4"
      class="qrCode_box"
      :class="'top' + cIdex"
    >
      <img
        v-if="cIdex == 1"
        class="qrCode_img"
        src="@/assets/r_img1.png"
        alt=""
      />
      <img
        v-if="cIdex == 3"
        class="qrCode_img"
        src="@/assets/r_img3.png"
        alt=""
      />
    </div>
    <div v-if="cIdex != null && cIdex == 2" class="r_phone_num">
      15801031606
    </div>
  </div>
</template>

<script>
export default {
  name: "rightBar",
  data() {
    return {
      cIdex: null,
    };
  },
  computed: {
    isMobile() {
      // 布尔值，指示当前设备是否被认为是移动设备
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
        userAgent
      );
    },
  },
  methods: {
    mouseOver(idx) {
      console.log("--idx--", idx);
      this.cIdex = idx;
    },
    mouseOut() {
      this.cIdex = null;
    },
    toTop() {
      // 调用window对象的scrollTo()方法并传入0作为参数，表示滚动至顶部位置
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 平滑滚动
      });
    },
  },
};
</script>

<style lang="scss">
.right_bar {
  position: fixed;
  width: 90px;
  height: 390px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #cecece;
  box-shadow: 4px 4px 30px 0px #00000033;
  right: 10px;
  top: 30%;
  z-index: 1000;
  display: flex;
  flex-direction: column;

  .item_box {
    width: 100%;
    cursor: pointer;
    color: #333333;
    .r_img {
      display: flex;
      width: 36px;
      height: 36px;
      margin: 30px auto 0;
    }
    .r_tx {
      font-family: PingFang SC;
      font-size: 16px;
      font-weight: 400;
      line-height: 22.4px;
      text-align: center;
    }
  }
  .item_box:hover {
    color: #008fd7;
  }
  .right_r {
    width: 0;
    height: 0;
    border: 20px solid transparent;
    border-right-color: #cecece;
    position: absolute;
    left: -40px;
    transform: translateY(-50%);
    z-index: 100;
  }
  .r1 {
    top: 15%;
  }
  .r2 {
    top: 40%;
  }

  .r3 {
    top: 60%;
  }
}
.qrCode_box {
  position: fixed;
  width: 160px;
  height: 160px;
  border-radius: 6px;
  background: #ffffff;
  border: 1px solid #cecece;
  box-shadow: 4px 4px 30px 0px #00000033;
  right: 120px;

  z-index: 1000;
  .qrCode_img {
    display: flex;
    margin: auto;
  }
}
.r_phone_num {
  position: fixed;
  font-family: PingFang SC;
  font-size: 26px;
  font-weight: 500;
  text-align: center;
  color: #333333;
  width: 200px;
  height: 60px;
  line-height: 60px;
  right: 120px;
  z-index: 1000;
  top: 44%;
  border-radius: 6px;
  background: #ffffff;
  border: 1px solid #cecece;
  box-shadow: 4px 4px 30px 0px #00000033;
}
.top1 {
  top: 28%;
}
.top3 {
  top: 47%;
}
</style>
